// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"590d25b7","513":"667a3d9e","703":"4ed47f63","787":"a578aafe"}[chunkId] + ".chunk.js";
};